import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
    FaUser,
    FaShoppingCart,
    FaCreditCard,
    FaList,
    FaHeart,
    FaMapMarkerAlt,
    FaBell,
    FaHeadset,
    FaCog,
    FaCommentAlt,
    FaChevronUp,
} from "react-icons/fa";
import axios from "axios";


import Management from "./Management";
import Closed from "./Closed";
import Pending from "./Pending";
import Food from "./Food";
import Orders from "./Orders";
// import MobileOrderspage from "./MobileOrderspage";

import "./Style.css";

const Fooddata = () => {
    const [categories, setCategories] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [posts, setPosts] = useState([]);
    const [activeCategory, setActiveCategory] = useState("Overview");

    const isMobile = window.innerWidth <= 768;
    const location = useLocation();
    const navigate = useNavigate();
    const scrollContainerRef = useRef(null);

    // Example click handler
    const handleClick = (category) => {
        setActiveCategory(category);
    };

    return (
        <div>
            {/* Breadcrumb */}
            <p
                className="breadcrumb maamaas-home-bredcum"
                style={{
                    position: "fixed",
                    top: isMobile ? "50px" : "80px",
                    left: isMobile ? "5px" : "275px",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    padding: "10px 0",
                    fontSize: isMobile ? "14px" : "18px",
                    fontWeight: isMobile ? "normal" : "bold",
                    textAlign: "center",
                    margin: 0,
                }}
            >
                {/* <Link
                    to="/Newmainlandingpage"
                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                >
                    Home
                </Link>
                <span className="separator"> &gt; </span> */}
                <Link

                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                >
                    Order_Management
                </Link>
                <span className="separator"> &gt; </span>
                <Link

                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                >
                    Food & Beverages
                </Link>
            </p>

            <div className="container-fluid">
                <div className="row">
                    <div className="row" style={{ marginTop: "40px" }}>
                        {/* Left Column */}
                        <div className="col-lg-2">

                        </div>

                        {/* Middle Column */}
                        <div
                            className="col-lg-7 col-md-7 col-sm-12 col-12 cartdta-mobile"
                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                        >
                            <div style={{ marginTop: "90px", borderRadius: "8px" }}>
                                {activeCategory === "Overview" && <Management />}
                                {activeCategory === "Closed" && <Closed />}
                                {activeCategory === "Pending" && <Pending />}
                                {activeCategory === "Food" && <Food />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-3">
                <Orders />
            </div>
        </div>
    );
};

export default Fooddata;
